/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Games_RemainingInputs */

const th_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เหลืออีก ${i?.count} นัด`)
};

const en_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} remaining`)
};

const ja_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`残り${i?.count}試合`)
};

const zh_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`还剩 ${i?.count} 场`)
};

const es_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`quedan ${i?.count}`)
};

const pt_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`faltam ${i?.count}`)
};

const id_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`sisa ${i?.count}`)
};

const fr_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} restants`)
};

const tl_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pa`)
};

const vi_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`còn ${i?.count}`)
};

const ko_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}경기 남음`)
};

const de_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`noch ${i?.count}`)
};

const ru_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`осталось ${i?.count}`)
};

const tr_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kaldı`)
};

const it_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ne restano ${i?.count}`)
};

const pl_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`pozostało ${i?.count}`)
};

const uk_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`лишилося ${i?.count}`)
};

const hi_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} शेष`)
};

const ar_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`بقيت ${i?.count}`)
};

const ms_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lagi`)
};

const bn_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}টি বাকি`)
};

const zh_tw2_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`還剩 ${i?.count} 場`)
};

const zh_hk2_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`還剩 ${i?.count} 場`)
};

const ur_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} باقی`)
};

const fa_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} بازی مانده`)
};

const sw_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} zimebaki`)
};

const nl_games_remaining = /** @type {(inputs: Games_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`nog ${i?.count}`)
};

/**
* | output |
* | --- |
* | "{count} remaining" |
*
* @param {Games_RemainingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const games_remaining = /** @type {((inputs: Games_RemainingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Games_RemainingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_games_remaining(inputs)
	if (locale === "ja") return ja_games_remaining(inputs)
	if (locale === "zh") return zh_games_remaining(inputs)
	if (locale === "es") return es_games_remaining(inputs)
	if (locale === "pt") return pt_games_remaining(inputs)
	if (locale === "id") return id_games_remaining(inputs)
	if (locale === "fr") return fr_games_remaining(inputs)
	if (locale === "tl") return tl_games_remaining(inputs)
	if (locale === "vi") return vi_games_remaining(inputs)
	if (locale === "ko") return ko_games_remaining(inputs)
	if (locale === "de") return de_games_remaining(inputs)
	if (locale === "ru") return ru_games_remaining(inputs)
	if (locale === "tr") return tr_games_remaining(inputs)
	if (locale === "it") return it_games_remaining(inputs)
	if (locale === "pl") return pl_games_remaining(inputs)
	if (locale === "uk") return uk_games_remaining(inputs)
	if (locale === "hi") return hi_games_remaining(inputs)
	if (locale === "ar") return ar_games_remaining(inputs)
	if (locale === "ms") return ms_games_remaining(inputs)
	if (locale === "bn") return bn_games_remaining(inputs)
	if (locale === "zh-TW") return zh_tw2_games_remaining(inputs)
	if (locale === "zh-HK") return zh_hk2_games_remaining(inputs)
	if (locale === "ur") return ur_games_remaining(inputs)
	if (locale === "fa") return fa_games_remaining(inputs)
	if (locale === "sw") return sw_games_remaining(inputs)
	if (locale === "nl") return nl_games_remaining(inputs)
	return en_games_remaining(inputs)
});